export default "__VITE_ASSET__70e783d3__"